import { createSlice } from '@reduxjs/toolkit';

const impersonationSlice = createSlice({
  name: 'impersonation',
  initialState: {
    isImpersonating: false,
    impersonation: {},
  },
  reducers: {
    setImpersonation: (state, action) => {
      state.impersonation = action.payload;
      state.isImpersonating = true;
    },
    stopImpersonating: (state) => {
      state.impersonation = {};
      state.isImpersonating = false;
    },
  },
});

export const { setImpersonation, stopImpersonating } = impersonationSlice.actions;
export default impersonationSlice.reducer;
